import { bindText, translate } from './i18n';

export function createElement<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  className?: string,
  parent?: HTMLElement
): HTMLElementTagNameMap[K] {
  const el = document.createElement(tag);
  if (className) {
    el.className = className;
  }
  if (parent) {
    parent.appendChild(el);
  }
  return el;
}

const textNodes = new WeakMap<HTMLElement, { node: Text; source: string }>();
export function setText(el: HTMLElement, text: string): void {
  const previous = textNodes.get(el);
  if (previous?.source === text) {
    if (previous.node.data !== translate(text)) previous.node.data = translate(text);
    return;
  }
  const node = previous?.node ?? document.createTextNode('');
  if (!previous) el.prepend(node);
  textNodes.set(el, { node, source: text });
  bindText(node, text);
}

export function addClass(el: HTMLElement, className: string): void {
  el.classList.add(className);
}

export function toggleClass(el: HTMLElement, className: string, force?: boolean): void {
  el.classList.toggle(className, force);
}

export function setStyle(el: HTMLElement, property: string, value: string): void {
  el.style.setProperty(property, value);
}

export function removeElement(el: HTMLElement): void {
  el.remove();
}

export function getUiRoot(): HTMLElement {
  const root = document.getElementById('ui');
  if (!root) {
    throw new Error('UI root element not found');
  }
  return root;
}

export function getCanvas(): HTMLCanvasElement {
  const canvas = document.getElementById('canvas');
  if (!canvas || !(canvas instanceof HTMLCanvasElement)) {
    throw new Error('Canvas element not found');
  }
  return canvas;
}
